import { formatNumber } from "common/helpers/formatNumber";
import { Guage160, GuageContainer, Needle } from "./GuageChart.elements";
import { GuageChartProps } from "./GuageChart.types";
import { ReactNode } from "react";
 

export const GuageChart = (props:GuageChartProps ): JSX.Element => {
  const {
    color,
    GuageSVG = Guage160,
    max_value = 160,
    value = 0,
    label = undefined as ReactNode,
    //ticks = [0, 20, 40, 60, 80, 100, 120, 140, 160],
    start_angle = 132.5,
    end_angle = -137,
    colors = {
      [`0-90`]: 'green',
      [`91-120`]: 'orange',
      [`121-160`]: 'red'
    } 
  } = props || {}

  const sweep_angle = Math.abs(end_angle - start_angle);
  const percentage = value / max_value;
  const cur_angle = sweep_angle * percentage;

  let className = 'guage-chart'

  Object.entries(colors).forEach(([range, color]) => {
    const [start, end] = range.split('-').map(Number);
    if (value >= start && value <= end) className += ` ${color}`
  })

  return (
    <GuageContainer className={className} progress={cur_angle || 0} circle_color={color}> 
      {GuageSVG}
      {Needle}
      <div className='value'>
        <div className='inner'>
          {formatNumber(value)}
        </div>
        {label && <div className='label'>{label}</div>}
      </div>
    </GuageContainer>
  )
}